/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A4Inputs */

const en_fc_home_faq_a4 = /** @type {(inputs: Fc_Home_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not directly, because there is no .prproj import yet. Export an FCP 7 XML, AAF or EDL from Premiere and import that into FilmCraft instead.`)
};

/**
* | output |
* | --- |
* | "Not directly, because there is no .prproj import yet. Export an FCP 7 XML, AAF or EDL from Premiere and import that into FilmCraft instead." |
*
* @param {Fc_Home_Faq_A4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a4 = /** @type {((inputs?: Fc_Home_Faq_A4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a4(inputs)
});
export { fc_home_faq_a4 as "fc.home.faq.a4" }